import React from 'react';
import css from './css.module.less';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import { LeftOutlined } from '@ant-design/icons';
import Layer from './Layers';
import { ImageCarouselSetting, PosterCarouselSetting } from './CarouselSetting';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  onClearData,
  onImageCollapseOpen,
  getImageBackData,
} from 'src/constrains/ResponsiveLayerEditor/slice';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import { EPreviewSize } from 'src/types/common/SalesChannel';

import { getState } from 'src/store';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';

const ImageEditor = (props) => {
  const d = useDispatch();
  const { buttons, animations, hoverAnimations } = React.useContext(
    ContentModuleGroupPreloadingContext,
  );
  const { onSubmit, isPoster, breakpoint, onChanged, name } = props;
  const isConvertible =
    breakpoint === EPreviewSize.MOBILE || breakpoint === EPreviewSize.TABLET;
  const handleOnSubmit = () => {
    d(onImageCollapseOpen([]));
    const state = getState();
    const data = getImageBackData()(state);
    onSubmit(data, handleOnClear);
  };

  const handleOnClear = () => {
    d(onClearData());
  };

  React.useEffect(() => {
    return () => {
      handleOnClear();
    };
  }, []);

  const _params: any = useParams();

  const { contentUuid } = _params;

  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });
  //const { linkSet } = props;
  return (
    <RightConfigWrapper
      title={
        <div className={css.goBackContainer} onClick={handleOnSubmit}>
          <LeftOutlined className={css.icon} />
          {name || (!isPoster ? 'Carousel' : 'Poster')}
        </div>
      }
      elements={[
        {
          key: 'setting',
          body: isPoster ? (
            <PosterCarouselSetting
              linkSet={linkSet}
              isImageOptional={isPoster}
              isConvertible={isConvertible}
              onChanged={onChanged}
              isPoster={isPoster}
            />
          ) : (
            <ImageCarouselSetting
              linkSet={linkSet}
              isImageOptional={isPoster}
              isConvertible={isConvertible}
              onChanged={onChanged}
            />
          ),
        },
        {
          key: 'layers',
          body: (
            <React.Fragment>
              <div className={css.layerTitle}>Other Layers</div>
              <Layer
                linkSet={linkSet}
                isConvertible={isConvertible}
                animations={animations}
                hoverAnimations={hoverAnimations}
                buttons={buttons}
                onChanged={onChanged}
              />
            </React.Fragment>
          ),
        },
      ]}
    />
  );
};
export default ImageEditor;
